import { useQuery } from 'react-query'
import { getCompanyFeatures } from '../services/company'
import { onQuerySuccess } from '../utils/queryResponse'
import { useState, useEffect } from 'react'

const STORAGE_KEY = 'sbr_company_features'

const readCached = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (raw) return JSON.parse(raw)
    } catch {}
    return { materialsEnabled: false }
}

const useCompanyFeatures = () => {
    const [features, setFeatures] = useState(readCached)

    const { data } = useQuery(['company', 'features'], getCompanyFeatures, {
        staleTime: 1000 * 60 * 5,
        retry: false,
    })

    useEffect(() => {
        onQuerySuccess(data, (result) => {
            const next = { materialsEnabled: result.materialsEnabled ?? false }
            setFeatures(next)
            try { localStorage.setItem(STORAGE_KEY, JSON.stringify(next)) } catch {}
        })
    }, [data])

    return features
}

export default useCompanyFeatures
